import carSedan from "assets/img/vehicle-damages-pattern/car-sedan.png";
import carHatchback3 from "assets/img/vehicle-damages-pattern/car-hatchback-3.png";
import carHatchback5 from "assets/img/vehicle-damages-pattern/car-hatchback-5.png";
import carPickup from "assets/img/vehicle-damages-pattern/car-pickup.png";
import carSuv from "assets/img/vehicle-damages-pattern/car-suv.png";
import carCombi from "assets/img/vehicle-damages-pattern/car-combi.png";
import bus from "assets/img/vehicle-damages-pattern/bus.png";
import busAutobus from "assets/img/vehicle-damages-pattern/bus-autobus.png";
import motorcycleChopper from "assets/img/vehicle-damages-pattern/motorcycle-chopper.png";
import motorcycle from "assets/img/vehicle-damages-pattern/motorcycle.png";
import quad from "assets/img/vehicle-damages-pattern/quad.png";
import scooter from "assets/img/vehicle-damages-pattern/scooter.png";
import trailer from "assets/img/vehicle-damages-pattern/trailer.png";
import truck from "assets/img/vehicle-damages-pattern/truck.png";
import truckMini from "assets/img/vehicle-damages-pattern/truck-mini.png";
import truckSemi from "assets/img/vehicle-damages-pattern/truck-semi.png";
import van from "assets/img/vehicle-damages-pattern/van.png";
import vanMini from "assets/img/vehicle-damages-pattern/van-mini.png";
import camper from "assets/img/vehicle-damages-pattern/camper.png";
import camperMini from "assets/img/vehicle-damages-pattern/camper-mini.png";
import boat1 from "assets/img/vehicle-damages-pattern/boat-1.png";
import boat2 from "assets/img/vehicle-damages-pattern/boat-2.png";
import boat3 from "assets/img/vehicle-damages-pattern/boat-3.png";
import boatTrailer from "assets/img/vehicle-damages-pattern/boat-trailer.png";

export const TYPE_CAR_SEDAN = 'car-sedan';
export const TYPE_CAR_HATCHBACK_3 = 'car-hatchback-3';
export const TYPE_CAR_HATCHBACK_5 = 'car-hatchback-5';
export const TYPE_CAR_COMBI = 'car-combi';
export const TYPE_CAR_SUV = 'car-suv';
export const TYPE_CAR_PICKUP = 'car-pickup';
export const TYPE_BUS = 'bus';
export const TYPE_BUS_AUTOBUS = 'bus-autobus';
export const TYPE_MOTORCYCLE = 'motorcycle';
export const TYPE_MOTORCYCLE_CHOPPER = 'motorcycle-chopper';
export const TYPE_QUAD = 'quad';
export const TYPE_SCOOTER = 'scooter';
export const TYPE_TRAILER = 'trailer';
export const TYPE_TRUCK = 'truck';
export const TYPE_TRUCK_MINI = 'truck-mini';
export const TYPE_TRUCK_SEMI = 'truck-semi';
export const TYPE_VAN = 'van';
export const TYPE_VAN_MINI = 'van-mini';
export const TYPE_CAMPER = 'camper';
export const TYPE_CAMPER_MINI = 'camper-mini';
export const TYPE_BOAT_1 = 'boat-1';
export const TYPE_BOAT_2 = 'boat-2';
export const TYPE_BOAT_3 = 'boat-3';
export const TYPE_BOAT_TRAILER = 'boat-trailer';

export const vehicleDamagesImagePatternByType = (vehicleDamagePatternImageType) => {
  switch (vehicleDamagePatternImageType) {
    case TYPE_CAR_SEDAN: return carSedan
    case TYPE_CAR_HATCHBACK_3: return carHatchback3
    case TYPE_CAR_HATCHBACK_5: return carHatchback5
    case TYPE_CAR_PICKUP: return carPickup
    case TYPE_CAR_SUV: return carSuv
    case TYPE_CAR_COMBI: return carCombi
    case TYPE_BUS: return bus
    case TYPE_BUS_AUTOBUS: return busAutobus
    case TYPE_MOTORCYCLE_CHOPPER: return motorcycleChopper
    case TYPE_MOTORCYCLE: return motorcycle
    case TYPE_QUAD: return quad
    case TYPE_SCOOTER: return scooter
    case TYPE_TRAILER: return trailer
    case TYPE_TRUCK: return truck
    case TYPE_TRUCK_MINI: return truckMini
    case TYPE_TRUCK_SEMI: return truckSemi
    case TYPE_VAN: return van
    case TYPE_VAN_MINI: return vanMini
    case TYPE_CAMPER: return camper
    case TYPE_CAMPER_MINI: return camperMini
    case TYPE_BOAT_1: return boat1
    case TYPE_BOAT_2: return boat2
    case TYPE_BOAT_3: return boat3
    case TYPE_BOAT_TRAILER: return boatTrailer
  }

  return null
}